import { render, staticRenderFns } from "./RobberyLocationQuestion.vue?vue&type=template&id=1cdc0388&scoped=true"
import script from "./RobberyLocationQuestion.vue?vue&type=script&lang=ts"
export * from "./RobberyLocationQuestion.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cdc0388",
  null
  
)

export default component.exports